export default __webpack_public_path__ + "static/media/GR00040-session_illustration.16a70ce4.svg";